import React, { useState, useCallback } from "react";
import { Dialog, ContentFormatter } from "@ebscois/react-component-library";
import {
  StyledDialogTitle,
  StyledDialogTitleActions,
  StyledTableWrapper,
} from "./_.styled";
import useContentPreprocessors from "../../hooks/useContentPreprocessors";
import DialogWindow from "../DialogWindow";
import FullTextLinks from "../FullTextLinks";

const ContentTableDialog = ({
  isDialogOpen,
  setIsDialogOpen,
  tableData,
  preProcessingData = {},
  telemetryData = {},
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [docId, setDocId] = useState([]);
  const [docType, setDocType] = useState([]);
  const [additionalFtLinks, setAdditionalLinks] = useState([]);
  const closeDialogWindow = useCallback(() => {
    setIsModalOpen(false);
  }, []);
  const openFtfDialog = (id, type, localAdditionalFtLinks) => {
    setDocId(id);
    setDocType(type);
    setAdditionalLinks(localAdditionalFtLinks);
    setIsModalOpen(true);
  };

  const { preProcessorInstance } = useContentPreprocessors({
    updates: [],
    openFtfDialog,
    ...preProcessingData,
  });
  return !preProcessorInstance ? (
    <></>
  ) : (
    <Dialog
      isOpen={isDialogOpen}
      data-testid="table-dialog"
      onRequestClose={() => setIsDialogOpen(false)}
    >
      <StyledDialogTitle data-testid="dialog-title">
        <StyledDialogTitleActions
          data-testid="dialog-actions"
          onRequestClose={() => setIsDialogOpen(false)}
        />
      </StyledDialogTitle>
      <StyledTableWrapper data-testid="table-wrapper">
        {tableData.children ? (
          <ContentFormatter
            preProcessors={preProcessorInstance}
            children={tableData.children}
          />
        ) : (
          tableData.inlineTable
        )}
      </StyledTableWrapper>

      <DialogWindow
        isOpened={isModalOpen}
        pageType="contentPageModal"
        handleClose={closeDialogWindow}
        windowMessage={
          <FullTextLinks
            docId={docId}
            docType={docType}
            additionalFtLinks={additionalFtLinks}
            telemetryData={telemetryData}
          />
        }
      />
    </Dialog>
  );
};

ContentTableDialog.displayName = "TableDialog";
export default ContentTableDialog;
